export default function capitalize(str: string) {
  if (!str) return "";
  return str
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const truncateAtWord = (
  text: string | null | undefined,
  maxLength: number,
  suffix = "...",
): string => {
  const normalized = (text ?? "").replace(/\s+/g, " ").trim();
  if (normalized.length <= maxLength) return normalized;

  const clipped = normalized.slice(0, maxLength);
  const lastSpace = clipped.lastIndexOf(" ");
  const head = lastSpace > 0 ? clipped.slice(0, lastSpace) : clipped;

  return `${head.replace(/[\s,;:.\-–—]+$/, "")}${suffix}`;
};

export const toCamelCase = (str: string) => {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase(),
    )
    .replace(/\s+/g, "");
};

const isNumericLabel = (value?: string | number | null) =>
  value !== null && value !== undefined && /^\d+$/.test(String(value).trim());

export const issuePart = (label: string, value?: string | number | null) => {
  if (value === null || value === undefined || String(value).trim() === "") {
    return null;
  }

  return isNumericLabel(value) ? `${label} ${value}` : String(value).trim();
};

export const issueLabel = (
  volume?: string | number | null,
  caption?: string | number | null,
) => {
  const v = issuePart("Volume", volume);
  const c = issuePart("Issue", caption);

  if (v && c && String(volume).trim() === String(caption).trim()) return v;

  return [v, c].filter(Boolean).join(", ");
};
